import { MyPermission } from '../../services/my-permission/my-permission.service'
import { MyPermittedAllocation } from '../../services/my-permitted-allocations/my-permitted-allocations.service'
import { ActiveAllocationManagerPayload, ActiveAllocationCurrentUser } from '../../services/active-allocation-manager/active-allocation-manager.service'
import { EventType } from '../../models/event-type'

export class ResetUserState {
  static readonly type = '[User] Reset State'
}

export class SetSelectedNodes {
  static readonly type = '[User] Set Selected Nodes'
  constructor(public selectedNodes: any[]) {}
}

export class DoReloadPage {
  static readonly type = '[User] Do Reload Page'
}

export class SetPermissions {
  static readonly type = '[User] Set Permissions'
  constructor(public permissions: MyPermission[]) {}
}

export class LoadPermissions {
  static readonly type = '[User] Load Permissions'
}

export class SetPermittedAllocations {
  static readonly type = '[User] Set Permitted Allocations'
  constructor(public allocations: MyPermittedAllocation[]) {}
}

export class LoadPermittedAllocations {
  static readonly type = '[User] Load Permitted Allocations'
}

export class SetActiveAllocation {
  static readonly type = '[User] Set Active Allocation'
  constructor(public payload: ActiveAllocationManagerPayload) {}
}

export class LoadActiveAllocationCurrentUser {
  static readonly type = '[User] Load Active Allocation Current User'
}

export class SetActiveAllocationCurrentUser {
  static readonly type = '[User] Set Active Allocation Current User'
  constructor(public payload: ActiveAllocationCurrentUser | null) {}
}

export class SetEventTypes {
  static readonly type = '[User] Set Event Types'
  constructor(public eventTypes: EventType[]) {}
}

export class LoadEventTypes {
  static readonly type = '[User] Load Event Types'
}
